import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { useAuth } from "./AuthProvider";
import Logout from './Logout'
import { User } from 'lucide-react';

export default function DropdownUser() {
  const auth = useAuth();
  return (
    <>
    {auth &&
    <Menu as="div" className="relative inline-block">
      <MenuButton className="inline-flex w-full items-center gap-x-1.5 rounded-full bg-transparent px-2 py-2 text-sm font-semibold text-white shadow-xs hover:bg-white/30">
        <User />
      </MenuButton>
      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg outline-1 outline-black/5 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
      >
        <div className="">
          <div className="block px-4 py-2 text-sm border-b-2 ">
            <div className="text-xs">Signed in as</div>
           { localStorage.getItem("user")}
          </div>
          <MenuItem>
            <div className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:text-gray-900 data-focus:outline-hidden">
              <Logout />
            </div>
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  }
  </>
  )
}
